import { API_BASE_URL } from '../config/api';
import { createApiError } from './apiError';

interface LoginData {
  email: string;
  password: string;
}

interface LoginResponse {
  message: string;
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
    studioName?: string;
  };
}

export const login = async (data: LoginData): Promise<LoginResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw createApiError(
        responseData?.error || 'Something went wrong',
        responseData?.code
      );
    }

    return responseData;
  } catch (error: any) {
    console.error('Login Error:', error);
    throw error;
  }
};
